import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import ja from './locales/ja/translation.json';
import ko from './locales/ko/translation.json';
import ru from './locales/ru/translation.json';
import pt from './locales/pt/translation.json';
import nl from './locales/nl/translation.json';
import pl from './locales/pl/translation.json';
import ar from './locales/ar/translation.json';
import zhCN from './locales/zh-CN/translation.json';
import zhTW from './locales/zh-TW/translation.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
  ru: { translation: ru },
  pt: { translation: pt },
  nl: { translation: nl },
  pl: { translation: pl },
  ar: { translation: ar },
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW }
};

const RTL_LANGUAGES = ['ar'];

// 把浏览器探测到的语言归一化到我们支持的 14 个之一，
// 重点是区分简体 (zh-CN) 与繁体 (zh-TW)。
const normalizeLanguage = (lng) => {
  if (!lng) {
    return 'en';
  }

  const lower = lng.toLowerCase();

  if (lower.startsWith('zh')) {
    if (/hant|tw|hk|mo/.test(lower)) {
      return 'zh-TW';
    }
    return 'zh-CN';
  }

  const base = lower.split('-')[0];
  return resources[base] ? base : 'en';
};

const applyDirection = (lng) => {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: Object.keys(resources),
    fallbackLng: 'en',
    load: 'currentOnly',
    keySeparator: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      caches: [],
      convertDetectedLanguage: normalizeLanguage
    }
  });

i18n.on('languageChanged', applyDirection);
applyDirection(i18n.language);

export default i18n;
